import { map } from 'rxjs';
import { z } from 'zod';

export function parseResponse<T>(schema: z.ZodSchema<T>) {
  return map((response: unknown) => schema.parse(response));
}
